import { render, staticRenderFns } from "./homeClass.vue?vue&type=template&id=6ff0bc81&scoped=true&"
import script from "./homeClass.vue?vue&type=script&lang=js&"
export * from "./homeClass.vue?vue&type=script&lang=js&"
import style0 from "./homeClass.vue?vue&type=style&index=0&id=6ff0bc81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0bc81",
  null
  
)

export default component.exports